import React, { useCallback, useEffect, useState } from "react";
import {
  Pencil,
  Trash,
  Plus,
  TrashSimple,
  UploadSimple,
  Key,
  Check,
} from "phosphor-react";
import TableWrapper from "components/common/table-wrapper";
import { DEBOUNCE_DELAY, initialMetaForTable } from "constants/common";
import CustomModal from "components/common/modal";
import ReferralCoordinatorForm from "./referralcoordinatorForm";
import PasswordChangeForm from "./passwordChangeForm";
import {
  getReferralCoordinators,
  createReferralCoordinators,
  updateReferralCoordinators,
  deleteBulkReferralCoordinators,
  deleteReferralCoordinators,
  updateReferralCoordinatorPassword,
  sendReferralCoordinatorConfirmationEmail,
} from "containers/referralcoordinator/api";
import {
  formatDate,
  highlightFirstMatch,
  formatDateTimeZone,
  capitalizeName,
  capitalizePlace,
} from "utils/common";
import Tooltip from "components/common/tooltip";
import debounce from "lodash/debounce";
import { useLocation } from "react-router-dom";
import { getOutreachLeaders } from "containers/outreachleaders/api";
let timeout;

const ReferralCoordinator = ({ onStatusChange }) => {
  const [referralCoordinatorList, setReferralCoordinatorList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [selectAll, setSelectAll] = useState(false);
  const [meta, setMeta] = useState(initialMetaForTable);
  const [loading, setLoading] = useState(true);
  const [
    selectedreferralCoordinator,
    setSelectedreferralCoordinator,
  ] = useState(0);
  const [
    isReferralCoordinatorModalVisible,
    setReferralCoordinatorModalVisible,
  ] = useState(false);
  const [isPasswordModalVisible, setPasswordModalVisible] = useState(false);
  const [
    currentReferralCoordinatorEdit,
    setCurrentReferralCoordinatorEdit,
  ] = useState("");
  const [outreachleaderList, setOutreachleaderList] = useState([]);
  const [refreshPage, setRefreshPage] = useState(false);
  const [outreachLeaderSearch, setOutreachLeaderSearch] = useState("");
  const [selectedFilter, setSelectedFilter] = useState("Filter");

  const location = useLocation();
  const debounceFn = useCallback((callback, delay) => {
    clearTimeout(timeout);
    timeout = setTimeout(callback, delay);
  }, []);

  const handleSetSearchQuery = (value) => {
    setMeta((prev) => ({ ...prev, search: value }));
    debounceFn(DEBOUNCE_DELAY, handleRefreshPage);
  };

  const handlePageChange = (value) => {
    setMeta((prevMeta) => ({ ...prevMeta, page: value }));
    setLoading(true);
    handleRefreshPage();
  };

  const handleRefreshPage = () => {
    setRefreshPage((pre) => !pre);
  };

  const handleReferralcoordinatorSubmission = async (
    coordinator,
    setSubmitting,
    setErrors
  ) => {
    try {
      if (typeof currentReferralCoordinatorEdit === "object") {
        const { id } = coordinator;
        const result = await updateReferralCoordinators(
          {
            referral_coordinator: {
              ...coordinator,
            },
          },
          id,
          setErrors
        );
        if (result) {
          handleCloseReferralCoordinatorModal();
          handleRefreshPage();
        }
      } else {
        const result = await createReferralCoordinators(
          {
            referral_coordinator: {
              ...coordinator,
            },
          },
          setErrors
        );
        if (result) {
          handleCloseReferralCoordinatorModal();
          handleRefreshPage();
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setSubmitting(false);
    }
  };

  const handleClosePasswordModal = () => {
    setCurrentReferralCoordinatorEdit("");
    setPasswordModalVisible(false);
  };
  const handleChangepasswordSubmission = async (data) => {
    try {
      const { id } = currentReferralCoordinatorEdit;
      const result = await updateReferralCoordinatorPassword(
        { referral_coordinator: { password: data.password } },
        id
      );
      if (result) {
        handleClosePasswordModal();
        // handleRefreshPage();
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleSelectAll = () => {
    const updatedCheckboxes = referralCoordinatorList.map((checkbox) => ({
      ...checkbox,
      checked: !selectAll,
    }));
    setReferralCoordinatorList(updatedCheckboxes);
    setSelectAll(!selectAll);
  };

  const handleCheckboxChange = (index) => {
    setReferralCoordinatorList((prevList) =>
      prevList.map((item, itemIndex) =>
        itemIndex === index ? { ...item, checked: !item.checked } : item
      )
    );
  };

  const handleCloseReferralCoordinatorModal = () => {
    setReferralCoordinatorModalVisible(false);
    setCurrentReferralCoordinatorEdit("");
  };

  const handleOpenReferralCoordinatorModal = () => {
    setReferralCoordinatorModalVisible(true);
  };

  const handleDeleteReferralCoordinators = async (id) => {
    const result = await deleteReferralCoordinators(id);
    if (result) handleRefreshPage();
  };
  const handleBulkDeleteReferralCoordinator = async () => {
    const selectedReferralCoordinatorIds = referralCoordinatorList
      ?.filter((coordinator) => coordinator.checked)
      .map((coordinator) => coordinator.id);
    const payload = {
      ids: selectedReferralCoordinatorIds,
    };
    const result = await deleteBulkReferralCoordinators(payload);
    if (result) handleRefreshPage();
  };
  const fetchReferralCoordinator = useCallback(
    async (searchString) => {
      setLoading(true);
      try {
        const result = await getReferralCoordinators({
          ...meta,
          filter: "referral_coordinator",
        });
        console.log("referral_coordinator are", result);
        if (result["referral_coordinators"]) {
          const data = result?.referral_coordinators.map((item) => ({
            ...item,
            checked: selectAll,
            created_at: item.created_at,
            updated_at: item.updated_at,
          }));
          setReferralCoordinatorList(data);
          setTotalCount(result?.meta.total_count);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }

      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [refreshPage, meta, selectAll]
  );

  useEffect(() => {
    fetchReferralCoordinator();
  }, [fetchReferralCoordinator]);

  useEffect(() => {
    setSelectedreferralCoordinator(
      selectAll
        ? referralCoordinatorList.length
        : referralCoordinatorList.reduce((accumulator, item) => {
            if (item.checked) {
              return accumulator + 1;
            } else return accumulator;
          }, 0)
    );
  }, [referralCoordinatorList, selectAll]);
  const fetchOutreachLeaders = useCallback(async (searchString) => {
    try {
      const result = await getOutreachLeaders({
        ...initialMetaForTable,
        search: searchString,
        active: true,
      });
      if (result?.outreach_leaders) {
        setOutreachleaderList(result.outreach_leaders);
      }
    } catch (error) {
      console.log(error);
    }
  }, []);
  const debouncedFetchOutreachLeaders = useCallback(
    debounce((searchString) => {
      fetchOutreachLeaders(searchString);
    }, DEBOUNCE_DELAY),
    []
  );
  useEffect(() => {
    debouncedFetchOutreachLeaders(outreachLeaderSearch);
  }, [debouncedFetchOutreachLeaders, outreachLeaderSearch]);
  const handleOutreachLeaderSearch = (searchString) => {
    setOutreachLeaderSearch(searchString);
  };
  const handleFilterSelect = (selectedOption) => {
    setSelectedFilter(selectedOption.label);
    onStatusChange(selectedOption);
  };
  const tableHeaders = [
    { label: "Staff Name", show: location.pathname.includes("/users") },
    { label: "Name", show: !location.pathname.includes("/users") },
    { label: "Email", show: true },
    // { label: "User Type", show: location.pathname.includes("/users") },
    { label: "Username", show: !location.pathname.includes("/users") },
    { label: "Outreach Leader", show: !location.pathname.includes("/users") },
    { label: "Last Login", show: true },
    { label: "Status", show: true },
    { label: "Date Created", show: true },
    { label: "", show: true },
  ];
  return (
    <>
      <TableWrapper
        searchPlaceholder="Search Referral Coordinator"
        setSearhQuery={handleSetSearchQuery}
        searchValue={meta.search}
        totalListCount={totalCount}
        pageSize={meta.perPage}
        currentPage={meta.page}
        isLoading={loading}
        onPageChange={handlePageChange}
        selectedItems={selectedreferralCoordinator}
        upload={true}
        uploadKey={"ReferralCoordinator"}
        actionButtons={
          selectedreferralCoordinator > 0
            ? [
                {
                  label: `Delete ${selectedreferralCoordinator} Items`,
                  classes: "danger-btn m-0-imp",
                  icon: <TrashSimple size={24} className="me-3" />,
                  handleClick: handleBulkDeleteReferralCoordinator,
                },
              ]
            : // !location.pathname.includes("/users")
              // ?
              [
                {
                  label: "Add Referral Coordinator",
                  classes: "primary-btn",
                  icon: <Plus size={24} className="me-3" />,
                  handleClick: handleOpenReferralCoordinatorModal,
                },
                {
                  label: "Referral Coordinator",
                  handlefilterSelect: handleFilterSelect,
                  dropdown: true,
                  dropdownOptions: [
                    { label: "Outreach Leader", value: "outreach_leader" },
                    {
                      label: "Outreach Staff",
                      value: "outreach_staff",
                    },
                  ],
                },
              ]
          // : [
          //     {
          //       label: "Outreach Staff",
          //       handlefilterSelect: handleFilterSelect,
          //       dropdown: true,
          //       dropdownOptions: [
          //         { label: "Outreach Leader", value: "outreach_leader" },
          //         { label: "Referral Coordinator", value: "referrals" },
          //       ],
          //     },
          //   ]
        }
      >
        <div className="container-fluid">
          <div className="table-responsive scrollable">
            <table className="table table-rows">
              <thead className="table-header">
                <tr>
                  <th>
                    <div className="form-check ps-3 mb-0">
                      <input
                        className="form-check-input light-grey-background"
                        type="checkbox"
                        checked={selectAll}
                        onChange={handleSelectAll}
                      />
                    </div>
                  </th>
                  {tableHeaders.map(
                    (header) =>
                      header.show && <th key={header.label}>{header.label}</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {referralCoordinatorList?.map((referralcoordinator, index) => (
                  <tr key={index}>
                    <td>
                      <div className="form-check ps-3 mb-0">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={referralcoordinator.checked}
                          onChange={() => handleCheckboxChange(index)}
                          value=""
                        />
                      </div>
                    </td>
                    <td>
                      {highlightFirstMatch(
                        capitalizeName(referralcoordinator.name || ""),
                        meta?.search || ""
                      )}
                    </td>

                    <td>
                      {highlightFirstMatch(
                        referralcoordinator.email,
                        meta.search
                      )}
                    </td>

                    {!location.pathname.includes("/users") && (
                      <td>
                        {highlightFirstMatch(
                          referralcoordinator.username,
                          meta.search
                        )}
                      </td>
                    )}
                    {/* {location.pathname.includes("/users") && (
                      <td>
                        {highlightFirstMatch(
                          referralcoordinator.usertype || "-",
                          meta?.search || ""
                        )}
                      </td>
                    )} */}

                    {!location.pathname.includes("/users") && (
                      <td>
                        {capitalizeName(
                          referralcoordinator?.outreach_leader?.name
                        )}
                      </td>
                    )}

                    <td>{referralcoordinator.last_sign_in_at}</td>
                    <td>
                      <div
                        className={`status ${
                          referralcoordinator.status === "active"
                            ? "active"
                            : "inactive"
                        }`}
                      >
                        {referralcoordinator.status.charAt(0).toUpperCase() +
                          referralcoordinator.status.slice(1)}
                      </div>
                    </td>
                    <td>{referralcoordinator.created_at}</td>
                    <td>
                      <Tooltip title="Edit">
                        <Pencil
                          size={24}
                          className="opacity-50"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setCurrentReferralCoordinatorEdit({
                              ...referralcoordinator,
                            });
                            handleOpenReferralCoordinatorModal();
                          }}
                        />
                      </Tooltip>{" "}
                      {!location.pathname.includes("/users") &&
                        referralcoordinator?.id && (
                          <Tooltip title="Delete">
                            <Trash
                              size={24}
                              className="ms-3 opacity-50"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                referralcoordinator?.id &&
                                  handleDeleteReferralCoordinators(
                                    referralcoordinator.id
                                  );
                              }}
                            />
                          </Tooltip>
                        )}
                      <Tooltip title="Change Password">
                        <Key
                          size={24}
                          className="ms-3 opacity-50"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setCurrentReferralCoordinatorEdit({
                              ...referralcoordinator,
                            });
                            setPasswordModalVisible(true);
                          }}
                        />
                      </Tooltip>
                      {!referralcoordinator.confirmed ? (
                        <Tooltip title="Send Confirmation Email">
                          <UploadSimple
                            size={24}
                            className="ms-3 opacity-50"
                            style={{ cursor: "pointer" }}
                            onClick={async () => {
                              await sendReferralCoordinatorConfirmationEmail(
                                referralcoordinator?.id
                              );
                            }}
                          />
                        </Tooltip>
                      ) : (
                        <Tooltip title="User Confirmed">
                          <Check size={24} className="ms-3 opacity-50" />
                        </Tooltip>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </TableWrapper>
      {isReferralCoordinatorModalVisible && (
        <CustomModal
          size="sm"
          show
          onHide={handleCloseReferralCoordinatorModal}
          heading={`${
            currentReferralCoordinatorEdit ? "Edit" : "Add"
          } Referral Coordinator`}
        >
          <ReferralCoordinatorForm
            handleQuestionSubmittion={handleReferralcoordinatorSubmission}
            handleClose={handleCloseReferralCoordinatorModal}
            currentReferralCoordinatorEdit={currentReferralCoordinatorEdit}
            outreachleaderList={outreachleaderList}
            handleOutreachLeaderSearch={handleOutreachLeaderSearch}
            outreachLeaderSearch={outreachLeaderSearch}
          />
        </CustomModal>
      )}
      {isPasswordModalVisible && (
        <CustomModal
          size="sm"
          show
          onHide={handleClosePasswordModal}
          heading={`Change Password`}
        >
          <PasswordChangeForm
            handleSubmit={handleChangepasswordSubmission}
            handleClose={handleClosePasswordModal}
            currentReferralCoordinatorEdit={currentReferralCoordinatorEdit}
          />
        </CustomModal>
      )}
    </>
  );
};

export default ReferralCoordinator;
